import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import logo from '../../assets/img/mh-logo.png';
import authImg from "../../assets/images/auth.png";
import eyeInvisible from "../../assets/svgs/eyeInvisible.svg";
import eyeVisible from "../../assets/svgs/eyeVisible.svg";
import studentSVG from "../../assets/svgs/studentReg.svg";
import { useTranslation } from "react-i18next";
import apiRequest from "services/axois";
import Cookies from "js-cookie";
import AlertServices from "services/alertServices";
import OtpInput from "react-otp-input";

const cookieTimeOut = 0.5;
const cookieOptions = {
  expires: cookieTimeOut,
  sameSite: "Lax",
  secure: false,
};
function Login() {
  const { t, i18n } = useTranslation();
  const [locale, setLocale] = useState(localStorage.getItem("lang") ||"en");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [, setErrorMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [forget, setForget] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");
  const [forgetError] = useState(false);
  const [resetUser, setResetUser] = useState(null);

  const [allData, setAllData] = useState({});

  const [showErrors, setShowErrors] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname.length < 2) {
    location.pathname = "/login";
  }

  useEffect(() => {
    const reason = sessionStorage.getItem("forced_logout_reason");
    if (!reason) return;

    sessionStorage.removeItem("forced_logout_reason");
    sessionStorage.removeItem("forced_logout_at");

    const lang = localStorage.getItem("lang") || i18n.language || "en";
    const isArabic = lang === "ar";

    const messages = {
      new_device: {
        en: "Your account was signed in on another device. For your security, this session has been ended.",
        ar: "تم تسجيل الدخول إلى حسابك من جهاز آخر. ولحماية حسابك، تم إنهاء هذه الجلسة.",
      },
      idle_timeout: {
        en: "Your session expired due to inactivity for more than 15 minutes. Please sign in again.",
        ar: "انتهت جلستك بسبب عدم النشاط لأكثر من 15 دقيقة. يرجى تسجيل الدخول مرة أخرى.",
      },
      session_invalid: {
        en: "Your session is no longer valid. Please sign in again.",
        ar: "جلستك الحالية لم تعد صالحة. يرجى تسجيل الدخول مرة أخرى.",
      },
    };

    const selected = messages[reason] || messages.session_invalid;
    AlertServices.AlertMessage(isArabic ? selected.ar : selected.en, "info", 7000);
  }, [i18n.language]);

  async function login() {
    setLoading(true);
    setLoginError(false);
    setErrorMessage("");

    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    localStorage.removeItem("privileges");
    localStorage.removeItem("type");
    localStorage.removeItem("studentId");

    if (!email || email === "" || !password || password === "") {
      AlertServices.AlertMessage(t("Please fill out all fields."), "error");
      setLoading(false);
      return;
    }

    try {
      const res = await apiRequest("post", "/auth/login", {
        email: email,
        password: password,
      });

      if (res.data?.status === 401) {
        throw new Error(t("Invalid email or password"));
      }

      if (res.data?.access_token) {
        localStorage.setItem("user", res.data.access_token);
        localStorage.setItem("userId", JSON.stringify(res.data?.userId));
        localStorage.setItem("type", res.data?.type);
        Cookies.set("userType", res.data?.type, cookieOptions);
        Cookies.set(
          "privileges",
          JSON.stringify(res?.data?.privileges),
          cookieOptions
        );

        setTimeout(() => {
          if (res.data?.type === "student") {
            localStorage.setItem("studentId", res.data?.studentId);
            navigate("/student/dashboard");
          } else if (res.data?.type === "corporate") {
            localStorage.setItem("corporateId", res.data?.corporateId);
        if(!res.data?.changePassword) {
            navigate("/corporate/dashboard");
            } else {
              navigate("/corporate/change-password-first");
            }
          } else if (res.data?.type === "Instructor") {
            navigate("/instructor/dashboard");
          } else if (res.data?.type === "Examiner") {
            navigate("/examiner/dashboard");
          } else {
            navigate("/admin/dashboard");
          }
        }, 1000);
      }
    } catch (error) {
      setLoading(false);
      setShowErrors(true);
      setLoginError(true);

      const errorMsg =
        error.response?.data?.message || t("Invalid email or password");
      setErrorMessage(errorMsg);
    }
  }

  const [otpNumber, setOtpNumber] = useState("");
  const [idFromOtp, setIdFromOtp] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const handleChange = (otpNumber) => {
    setOtpNumber(otpNumber);
  };

  async function createOTP() {
    const nid = forgetEmail.trim();
    if (!nid) {
      AlertServices.AlertMessage(t("Please enter your National ID"), "error");
      return;
    }
    if (!/^\d{10}$/.test(nid)) {
      AlertServices.AlertMessage(t("National ID must be exactly 10 digits"), "error");
      return;
    }

    try {
      const res = await apiRequest("post", "/users/reset-otp", { ID: nid }, { suppressErrorToast: true });

      if (!res.data?.id || res.data?.statusCode === 404) {
        AlertServices.AlertMessage(t("National ID does not exist"), "error");
        return;
      }

      setIdFromOtp(res.data.id);
      setResetUser({ id: res.data.id, phone: res.data.phone });
      setShowNewPassword(true);
    } catch (error) {
      console.error("NID Check Error:", error);
      AlertServices.AlertMessage(
        error.data?.message || error.message || t("Error verifying National ID. Try again."),
        "error"
      );
    }
  }

  const [checkPassword, setCheckPassword] = useState(false);

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8)
      errors.push(t("Password must be at least 8 characters."));
    if (!/[A-Z]/.test(password))
      errors.push(t("Password must contain an uppercase letter."));
    if (!/[a-z]/.test(password))
      errors.push(t("Password must contain a lowercase letter."));
    if (!/[0-9]/.test(password))
      errors.push(t("Password must contain a number."));
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      errors.push(t("Password must contain a special character."));

    if (errors.length > 0) {
      setPasswordErrorMessage(errors[0]);
      setCheckPassword(true);
      return false;
    }

    setCheckPassword(false);
    setAllData({ ...allData, newPassword: password });
    return true;
  };

  async function updatePassword(event) {
    if (event) event.preventDefault();

    if (!idFromOtp || !forgetEmail) {
      AlertServices.AlertMessage(
        t("User information missing. Please try again."),
        "error"
      );
      return;
    }

    const newPassword = allData.newPassword;
    const confirmPassword = allData.confirmPassword;

    if (!newPassword) {
      setPasswordErrorMessage(t("Please enter a new password"));
      setCheckPassword(true);
      return;
    }

    if (!validatePassword(newPassword)) {
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordErrorMessage(t("Passwords do not match"));
      setCheckPassword(true);
      return;
    }

    try {
      const response = await apiRequest("post", "/users/verify-reset-otp", {
        id: idFromOtp,
        otp: otpNumber,
        password: newPassword,
        nid: forgetEmail.trim(),
      }, { suppressErrorToast: true });

      if (response.data?.statusCode === 404) {
        AlertServices.AlertMessage(t("Invalid OTP or National ID"), "error");
        return;
      }

      if (
        response.data === "success" ||
        response.status === 200 ||
        response.status === 201
      ) {
        AlertServices.AlertMessage(
          t("Password updated successfully!"),
          "success"
        );
        resetForgotPasswordFlow();
      } else {
        AlertServices.AlertMessage(
          t("Error updating password. Please try again."),
          "error"
        );
      }
    } catch (error) {
      console.error("Password Update Error:", error);
      // apiRequest throws a plain Error with .message = backend message, .data = response body
      const msg = (error.data?.message || error.message || "").toLowerCase();
      if (msg.includes("otp") || msg.includes("invalid")) {
        AlertServices.AlertMessage(t("Invalid OTP or National ID. Please try again."), "error");
      } else {
        AlertServices.AlertMessage(t("Error updating password"), "error");
      }
    }
  }

  function resetForgotPasswordFlow() {
    setShowNewPassword(false);
    setShowNewPass(false);
    setShowConfirmPass(false);
    setForget(false);
    setForgetEmail("");
    setOtpNumber("");
    setIdFromOtp(null);
    setResetUser(null);
    setAllData({});
    setCheckPassword(false);
    setPasswordErrorMessage("");
  }

  // const handleChangeWithName = (value, name) => {
  //   setAllData({ ...allData, [name]: value });
  // };

  // const validatePassword = (password) => {
  //   const errors = [];

  //   // Length check
  //   // if (password.length < 8 || password.length > 20) {
  //   //   errors.push("Password must be between 8 and 20 characters.");
  //   // }

  //   if (password.length < 8) {
  //     errors.push("Password must be more than 8");
  //   }

  //   // Complexity checks
  //   if (!/[A-Z]/.test(password)) {
  //     errors.push("Password must contain at least one uppercase letter.");
  //   }
  //   if (!/[a-z]/.test(password)) {
  //     errors.push("Password must contain at least one lowercase letter.");
  //   }
  //   if (!/[0-9]/.test(password)) {
  //     errors.push("Password must contain at least one number.");
  //   }
  //   if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
  //     errors.push("Password must contain at least one special character.");
  //   }
  //   if (errors.length > 0) {
  //     setPasswordErrorMessage(errors[0]);
  //     setCheckPassword(true);
  //     return;
  //   }
  //   setAllData({ ...allData, newPassword: password });
  //   setCheckPassword(false);
  // };
  // async function updatePassword(user) {
  //   try {
  //     let password = allData.newPassword;
  //     let rePassword = allData.confirmPassword;
  //     //// console.log('pass: ',password,rePassword);
  //     if (password !== rePassword) {
  //       setCheckPassword(true);
  //       return;
  //     }
  //     let userId =
  //     setCheckPassword(false);
  //     let resetData = {
  //       userId: user.userId,
  //       password,
  //       rePassword,
  //     };
  //     let res = await apiRequest("post", "/users/update-password", resetData);
  //     if (res.data && (res.status === 200 || res.status === 201)) {
  //       setPasswordChanged(true);
  //       AlertServices.AlertMessage(
  //         t("the password have been changed successfully!"),
  //         "success"
  //       );
  //       return;
  //     }
  //     // failed
  //   } catch (error) {
  //     // error
  //   }
  // }

  return (
    <>

      <div className="fixed top-0 left-0 w-full z-[99] sm:bg-[#fff] bg-primary">
        <div className="flex items-center justify-between w-[97%] mx-auto py-4">
          <img className="w-40" src="/assets/images/arkkan-logo.png" alt="logo" />
        </div>
        <div className="language-selector" style={{textAlign: "end",marginRight: "50px",marginLeft: "50px" }}>
  <select
    onChange={(e) => {
      const value = e.target.value;
      setLocale(value);
      i18n.changeLanguage(value); 
      localStorage.setItem("lang", value);
    }}
    value={locale}
    className="p-2 border rounded-md bg-white text-black"
  >
    <option value="en">English</option>
    <option value="ar">العربية</option>
  </select>
</div>
      </div>
      {/* Language Selector */}
       

     

      <div className="w-full pb-20 h-full mt-20">
        <div className="lg:w-[80%] w-[95%] h-full mx-auto flex justify-center gap-8 pt-24">
          <div className="flex-1 md:block hidden">
            <img src={authImg} alt="Auth" className="w-[80%]" />
          </div>

          <div className="flex-1">
            <div
              className={`flex items-center gap-12
                  ${locale === "en" ? "justify-start" : "justify-end"}
                  `}
            >
              {["login", "register"].map((item, i) =>
                item !== "products" ? (
                  <div
                    onClick={() => {
                      navigate(`/${item}`);
                    }}
                    className={`font-semibold text-xl cursor-pointer
            ${
              location.pathname.includes(item)
                ? 'text-primary relative after:content-[""] after:absolute after:-bottom-3 after:left-0 after:w-full after:h-[5px] after:bg-[#046f6d]'
                : ""
            } `}
                    key={i}
                  >
                    {item === "login" ? t("Login") : t("Register")}
                  </div>
                ) 
                : (
                  <div
                    onClick={() => {
                      navigate(`/products`);
                    }}
                    className={`font-semibold text-xl cursor-pointer`}
                    key={i}
                  >
                    {t("Products")}
                  </div>
                )
              )}
            </div>
            {location.pathname.includes("login") ? (
              <div className="mt-12">
                {forget ? (
                  <form className="flex flex-col gap-4">
                    {showNewPassword ? (
                      <div className="flex flex-col gap-4">
                        {/* OTP info */}
                        <p className="text-sm text-gray-500 text-center">
                          {t("A 4-digit OTP has been sent to your registered phone/email.")}
                        </p>
                        {resetUser?.phone && (
                          <p className="text-sm font-semibold text-center">
                            {t("Code sent to")}:{" "}
                            {"*".repeat(Math.max(0, (resetUser.phone?.length || 0) - 2)) +
                              (resetUser.phone?.slice(-2) || "")}
                          </p>
                        )}

                        {/* OTP input */}
                        <div className="flex flex-col gap-1 items-center">
                          <label className="text-sm font-medium">{t("Enter OTP")}</label>
                          {/* dir="ltr" is required — OTP digits are always left-to-right regardless of locale */}
                          <div className="flex mt-1 justify-center" dir="ltr">
                            <OtpInput
                              value={otpNumber}
                              onChange={handleChange}
                              numInputs={4}
                              renderSeparator={<span>&nbsp;&nbsp;</span>}
                              inputType="tel"
                              renderInput={(props) => (
                                <input
                                  {...props}
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  className="border-2 border-gray-300 text-lg text-center rounded-lg focus:outline-none focus:border-primary"
                                  style={{ width: "44px", height: "44px", fontSize: "20px", textAlign: "center", margin: "0", padding: "0" }}
                                />
                              )}
                            />
                          </div>
                        </div>

                        {/* New Password */}
                        <div className="flex flex-col gap-2 relative">
                          <label>{t("New Password")}</label>
                          <input
                            type={showNewPass ? "text" : "password"}
                            placeholder="********"
                            className="py-2 px-3 rounded-md border focus:border-primary"
                            onChange={(e) => validatePassword(e.target.value)}
                          />
                          <div className={`absolute cursor-pointer top-[60%] ${i18n.language === "ar" ? "left-2" : "right-2"}`}>
                            {showNewPass ? (
                              <img src={eyeInvisible} alt="Hide" onClick={() => setShowNewPass(false)} className="w-[22px]" />
                            ) : (
                              <img src={eyeVisible} alt="Show" onClick={() => setShowNewPass(true)} className="w-[22px]" />
                            )}
                          </div>
                        </div>

                        {/* Confirm Password */}
                        <div className="flex flex-col gap-2 relative">
                          <label>{t("Confirm Password")}</label>
                          <input
                            type={showConfirmPass ? "text" : "password"}
                            placeholder="********"
                            className="py-2 px-3 rounded-md border focus:border-primary"
                            onChange={(e) =>
                              setAllData({ ...allData, confirmPassword: e.target.value })
                            }
                          />
                          <div className={`absolute cursor-pointer top-[60%] ${i18n.language === "ar" ? "left-2" : "right-2"}`}>
                            {showConfirmPass ? (
                              <img src={eyeInvisible} alt="Hide" onClick={() => setShowConfirmPass(false)} className="w-[22px]" />
                            ) : (
                              <img src={eyeVisible} alt="Show" onClick={() => setShowConfirmPass(true)} className="w-[22px]" />
                            )}
                          </div>
                        </div>

                        {checkPassword && (
                          <span className="text-red-400">{passwordErrorMessage}</span>
                        )}

                        <div
                          onClick={() => resetForgotPasswordFlow()}
                          className="w-max font-semibold text-primary hover:cursor-pointer hover:underline"
                        >
                          {t("Back to Login")}
                        </div>

                        <button
                          className="py-2 px-6 bg-[#046f6d] text-white rounded-lg hover:bg-primaryHover"
                          onClick={(event) => {
                            event.preventDefault();
                            updatePassword();
                          }}
                        >
                          {t("Reset Password")}
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="flex flex-col gap-2">
                          <label>{t("Enter National ID")}</label>
                          <input
                            type="text"
                            placeholder={t("National ID")}
                            className="py-2 px-3 rounded-md border"
                            value={forgetEmail}
                            onChange={(e) => setForgetEmail(e.target.value)}
                          />
                        </div>

                        {showErrors && forgetError && (
                          <span className="text-red-400">
                            {t("Invalid National ID")}
                          </span>
                        )}

                        <div className="mt-2">
                          <div
                            onClick={() => setForget(false)}
                            className="my-4 w-max font-semibold text-primary hover:cursor-pointer hover:underline"
                          >
                            {t("Login")}
                          </div>

                          <button
                            disabled={loading}
                            className="py-2 px-6 bg-[#046f6d] text-white rounded w-full"
                            onClick={(event) => {
                              event.preventDefault();
                              createOTP();
                            }}
                          >
                            {t("Submit")}
                          </button>
                        </div>
                      </>
                    )}
                  </form>
                ) : (
                  <form className="flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                      <label>{t("Email / ID")}</label>
                      <input
                        type="text"
                        placeholder="mail@example.com"
                        className="py-2 px-3 rounded-md border"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="flex flex-col gap-2 relative">
                      <label>{t("Password")}</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="**********"
                        className="py-2 px-3 rounded-md border"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {/* //<div className="absolute right-2 top-[55%] cursor-pointer"> */}

                      <div className={`absolute cursor-pointer top-[55%] ${
  i18n.language === 'ar' ? 'left-2' : 'right-2'
} flex items-center text-gray-600 focus:outline-none`}>
                        {showPassword ? (
                          <img
                            src={eyeInvisible}
                            alt="Hide"
                            onClick={() => setShowPassword(false)}
                            className="w-[24px]"
                          />
                        ) : (
                          <img
                            src={eyeVisible}
                            alt="Show"
                            onClick={() => setShowPassword(true)}
                            className="w-[24px]"
                          />
                        )}
                      </div>
                    </div>

                    {loginError && (
                      <span className="text-red-400">
                        {t("Invalid email or password")}
                      </span>
                    )}

                    <div className="mt-2">
                      <div
                        onClick={() => setForget(true)}
                        className="my-4 w-max font-semibold text-primary hover:cursor-pointer hover:underline"
                      >
                        {t("Forgot Password ?")}
                      </div>

                      <button
                        disabled={loading}
                        className="py-2 px-6 bg-[#046f6d] text-white rounded w-full"
                        onClick={(event) => {
                          event.preventDefault();
                          setLoading(true);
                          login();
                        }}
                      >
                        {t("Login")}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            ) : (
              <div
                className={`flex flex-col gap-4 w-full mt-12
      ${locale === "en" ? "justify-start" : "justify-end"}
      `}
              >
                <p
                  className={`text-grayText w-full
          ${locale === "en" ? "" : ""}
          `}
                >
                  {t(
                    "Select one of these option to determine how will you register"
                  )}
                </p>
                <Link to="/student-register">
                  <div
                    className={`flex items-center gap-4 mt-4
          ${locale === "en" ? "flex-row" : "flex-row-reverse"}
          `}
                    onClick={() => {}}
                  >
                    <div className="w-[60px] h-[60px] flex items-center justify-center bg-lightBlue rounded-full">
                      <img src={studentSVG} alt="SVG" />
                    </div>
                    <p className="font-semibold">{t("I Am Student")}</p>
                  </div>
                </Link>
                {/* Blocked for now Public Registeration of Corporate, Training and Medical Centers  
                <Link to="/corporate-register">
                  <div
                    className={`flex items-center gap-4 mt-4
          ${locale === "en" ? "flex-row" : "flex-row-reverse"}
          `}
                  >
                    <div className="w-[60px] h-[60px] flex items-center justify-center bg-lightBlue rounded-full">
                      <img src={corporateSVG} alt="SVG" />
                    </div>
                    <p className="font-semibold">{t("Corporate")}</p>
                  </div>
                </Link> */}
                {/* <Link to="/training-register">
                  <div
                    className={`flex items-center gap-4 mt-4
          ${locale === "en" ? "flex-row" : "flex-row-reverse"}
          `}
                  >
                    <div className="w-[60px] h-[60px] flex items-center justify-center bg-lightBlue rounded-full">
                      <img src={trainingSVG} alt="SVG" />
                    </div>
                    <p className="font-semibold">{t("Training Center")}</p>
                  </div>
                </Link>
                <Link to="/medical-register">
                  <div
                    className={`flex items-center gap-4 mt-4
          ${locale === "en" ? "flex-row" : "flex-row-reverse"}
          `}
                  >
                    <div className="w-[60px] h-[60px] flex items-center justify-center bg-lightBlue rounded-full">
                      <img src={medicalSVG} alt="SVG" />
                    </div>
                    <p className="font-semibold">{t("Medical Center")}</p>
                  </div>
                </Link> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
